import { render, staticRenderFns } from "./Tabla_Registro_Lectura_Laboratorio.vue?vue&type=template&id=77ad11d8&scoped=true&"
import script from "./Tabla_Registro_Lectura_Laboratorio.vue?vue&type=script&lang=js&"
export * from "./Tabla_Registro_Lectura_Laboratorio.vue?vue&type=script&lang=js&"
import style0 from "./Tabla_Registro_Lectura_Laboratorio.vue?vue&type=style&index=0&id=77ad11d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ad11d8",
  null
  
)

export default component.exports